module.exports = __webpack_public_path__ + "img/dsci0002.0a64df3a.jpg";